export default __webpack_public_path__ + "static/media/temp stay E6 - Student Exchange.0786cb7e.jpg";